exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\n *+------------------------------------------------------------------------+\n *| Licensed Materials - Property of IBM\n *| IBM Cognos Products: Explore\n *| (C) Copyright IBM Corp. 2018, 2020\n *|\n *| US Government Users Restricted Rights - Use, duplication or disclosure\n *| restricted by GSA ADP Schedule Contract with IBM Corp.\n *+------------------------------------------------------------------------+\n */\n\n/*this scss file is defined for Loading UI component*/\n\n.explore__loading__container {\n  display: flex;\n  flex-flow: column;\n  margin: auto;\n  height: 100%;\n}\n\n.explore__loading__container__cancelText {\n  text-align: center;\n  cursor: pointer;\n  color: #2d74da;\n}\n\n.explore__loading__icon {\n  margin: 0 auto;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-1!./node_modules/postcss-loader??ref--1-2!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js??ref--1-4!./src/js/components/empty/loading.scss
// module id = 156
// module chunks = 4